import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import { buttonsV2 as Buttons } from '@breezeway/brzw-components';

import './accordion.scss';

const { BUTTON_SIZES, BUTTON_THEMES } = Buttons.constants;
const CLASS_NAME = 'accordion-component';

const renderActionButton = action =>
  action.icon && !action.text ? (
    <Buttons.IconButton
      iconName={action.icon}
      onClick={action.onClick}
      size={BUTTON_SIZES.ICON_LARGE}
      theme={action.theme}
    />
  ) : (
    <Buttons.IconTextButton
      iconNameLeft={action.icon}
      onClick={action.onClick}
      size={BUTTON_SIZES.MEDIUM}
      theme={action.theme}
    >
      {action.text}
    </Buttons.IconTextButton>
  );

export class Accordion extends Component {
  renderActions() {
    const { actions, actionsClassName } = this.props;

    return (
      <div className={classnames(`${CLASS_NAME}__actions`, actionsClassName)}>
        {_.map(actions, (action, index) => (
          <div
            className={`${CLASS_NAME}__action-button`}
            key={`${CLASS_NAME}__action-button-${index}`}
          >
            {React.isValidElement(action) ? action : renderActionButton(action)}
          </div>
        ))}
      </div>
    );
  }

  renderBadge() {
    const { active, badgeCount, icon, onClick, showIcon } = this.props;

    return showIcon ? (
      icon
    ) : (
      <div
        className={classnames(`${CLASS_NAME}__badge`, {
          [`${CLASS_NAME}__badge--active`]: active && onClick,
        })}
      >
        {badgeCount}
      </div>
    );
  }

  render() {
    const { active, children, className, isExpanded, onClick, subtitle, title } = this.props;
    return (
      <div
        className={classnames(CLASS_NAME, className, {
          [`${CLASS_NAME}--active`]: active,
        })}
      >
        <div
          className={classnames(`${CLASS_NAME}__title-wrapper`, {
            [`${CLASS_NAME}__title-wrapper--active`]: active,
            [`${CLASS_NAME}__title-wrapper--expanded`]: isExpanded,
            [`${CLASS_NAME}__title-wrapper--clickable`]: onClick,
          })}
          onClick={onClick}
          role='presentation'
        >
          <div className={`${CLASS_NAME}__left-side-wrapper`}>
            {this.renderBadge()}
            {title}
            {subtitle}
          </div>
          <div className={`${CLASS_NAME}__actions`}>{this.renderActions()}</div>
        </div>
        {isExpanded && children}
      </div>
    );
  }
}

Accordion.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        text: PropTypes.string,
        icon: PropTypes.string,
        onClick: PropTypes.func.isRequired,
        theme: PropTypes.oneOf(_.values(BUTTON_THEMES)),
      }),
      PropTypes.node,
    ]),
  ),
  actionsClassName: PropTypes.string,
  active: PropTypes.bool,
  badgeCount: PropTypes.number,
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.node,
  isExpanded: PropTypes.bool,
  onClick: PropTypes.func,
  showIcon: PropTypes.bool,
  subtitle: PropTypes.node,
  title: PropTypes.string,
};

Accordion.defualtProps = {
  active: false,
  actionsClassName: '',
  className: '',
  badgeCount: 0,
  icon: '',
  isExpanded: false,
  showIcon: false,
  title: '',
};

export default Accordion;
